import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { FRAGMENT_JOB } from 'src/graphql/job';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation ImportBrandTermsForWebsiteOrPdf(
    $workspaceId: ID!
    $brandVoiceId: ID!
    $input: PerformanceCenterCustomerResourceInputType!
    $glossary: Boolean!
  ) {
    importBrandTermsForWebsiteOrPdf(
      workspaceId: $workspaceId
      brandVoiceId: $brandVoiceId
      input: $input
      glossary: $glossary
    ) {
      ...Job
    }
  }
  ${FRAGMENT_JOB}
`;

export const importBrandTermsForWebsiteOrPdf = ({ workspaceId, brandVoiceId, input, glossary }) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { workspaceId, brandVoiceId, input, glossary },
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
